import clsx from 'clsx';
import type { Ref } from 'react';
import React, { forwardRef } from 'react';

interface ITextField extends React.HTMLProps<HTMLInputElement> {
  id: string;
  requirements?: string;
}

const TextField = forwardRef(
  (
    {
      id,
      className,
      label,
      required,
      onChange,
      requirements,
      onBlur,
      ...rest
    }: ITextField,
    ref: Ref<HTMLInputElement>
  ) => {
    const [hideLabel, setHideLabel] = React.useState(false);

    return (
      <div className={clsx('relative', className)}>
        <label
          className={clsx(
            'pointer-events-none absolute top-2 block text-lg text-grayAlt-500',
            hideLabel && 'sr-only'
          )}
          htmlFor={id}
        >
          {label}
          {required && <span className="text-grayAlt-500">* </span>}
          {requirements && (
            <span className="text-sm text-grayAlt-500">({requirements})</span>
          )}
        </label>
        <input
          id={id}
          className="w-full border-b border-grayAlt-500 bg-transparent py-2 text-lg text-cream outline-0"
          ref={ref}
          onChange={(e) => {
            onChange && onChange(e);
            if (e.target.value !== '') {
              setHideLabel(true);
            }
            if (e.target.value.length === 0) {
              setHideLabel(false);
            }
          }}
          onBlur={(e) => {
            onBlur && onBlur(e);
            if (e.target.value.length === 0) {
              setHideLabel(false);
            }
          }}
          required={required}
          {...rest}
        />
      </div>
    );
  }
);

TextField.displayName = 'TextField';

export default TextField;
